import $ from "jquery";
import { loadZendeskChat } from "../js/chat-helper";

window.$ = $;

class Brand {
  constructor({id, name, companyName, iconUrl, active, dateActivated, accountDetailsList, companyWebsite, workspaceTagIds, trialExpiration, agencyId, upcomingPostsToday, upcomingPostsThisWeek, c2Status}) {
      this.id = id
      this.companyName = name ||companyName
      this.iconUrl = iconUrl || '../res/brand_icon.svg'
      this.dateActivated = dateActivated
      this.active = active
      this.upcomingPostsToday = upcomingPostsToday
      this.upcomingPostsThisWeek = upcomingPostsThisWeek
      this.loadingStats = null
      this.accounts = accountDetailsList
      this.companyWebsite = companyWebsite
      this.workspaceTagIds = workspaceTagIds
      this.trialExpiration = trialExpiration
      this.agencyId = agencyId
      this.c2Status = c2Status
  }
}

class User {
  constructor({ id, email, name, pictureUrl, role, brands, pendingSignup, canApprove, requireApprovals, inviteLink}) {
      this.id = id
      this.email = email
      this.name = name
      this.pictureUrl = pictureUrl || "../res/user-no-picture.png";
      this.role = role
      this.brandList = brands
      this.canApprove = canApprove
      this.pendingSignup = pendingSignup
      this.requireApprovals = requireApprovals
      this.inviteLink = inviteLink
  }
}

function isUndefined(foo) {
  return foo == undefined;
}

function isEmpty(foo) {
  return isUndefined(foo) || foo.length == 0;
}

function isNotEmpty(foo) {
  return !isEmpty(foo);
}

function brandSearchFilter(brand, searchTerm) {
  return (
    (brand.companyWebsite != null &&
      brand.companyWebsite.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (brand.companyName != null &&
      brand.companyName.toLowerCase().includes(searchTerm.toLowerCase()))
  );
}

function userSearchFilter(user, searchTerm) {
  return (
    (user.email != null &&
      user.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (user.name != null &&
      user.name.toLowerCase().includes(searchTerm.toLowerCase()))
  );
}

function isVendastaPartner(user) {
  return user.partner === "VENDASTA" && user.partnerUserInfo;
}

function displayVendastaBanner(user) {
  var js = document.createElement("script");
  js.async = true;
  js.src =
    "https://www.cdnstyles.com/static/product_navbar/v1/product_navbar.js";
  js.setAttribute("data-url", user.partnerUserInfo.product_navbar_data_url);
  js.setAttribute("data-account-id", user.partnerUserInfo.partner_account_id);
  js.setAttribute("data-app-id", "MP-X4JQT737FWRLRD747NQ8F8RQ88ZPXRJ7");
  js.setAttribute("target-element-class", "vendasta-dashboard-banner");
  document.body.appendChild(js);
}

function determineAndSetIfUserIsInternal(user) {
  if (
    isNotEmpty(user.role) &&
    (user.role == "BRAND_MANAGER" ||
      user.role == "BRAND_ADMIN" ||
      user.role == "ADMIN")
  ) {
    user.internal = true;
  }
}

function setAdminBannerVisibility(organizations, user) {
  let counter = 0;
  if (isEmpty(organizations)) {
    return;
  }

  for (let i = 0; i < organizations.length; i++) {
    if (isEmpty(organizations[i].companyName)) {
      organizations[i].companyName = counter++;
    }
  }

  // show the admin dashboard if the user has access to multiple organizations
  let userHasAccessToMultipleOrgs =
    isNotEmpty(organizations) && organizations.length > 1;
  let userHasNoPartnerAffiliation = user.partner === "NONE";
  return (
    userHasAccessToMultipleOrgs &&
    (userHasNoPartnerAffiliation ||
      user.featureFlags.vendastaShowAllOrgsEnabled)
  );
}

function setWhiteLabelAndChat(rs, scp) {
  if (rs.customer.whiteLabelEnabled && scp.isDefined(rs.customer.whiteLabel)) {
    if (scp.isNotEmpty(rs.customer.whiteLabel.logo)) {
      rs.whiteLabelLogo = rs.customer.whiteLabel.logo;
    }

    if (scp.isNotEmpty(rs.customer.whiteLabel.companyName)) {
      rs.companyName = rs.customer.whiteLabel.companyName;
    } else {
      rs.companyName = "Cloud Campaign";
    }

    if (scp.isNotEmpty(rs.customer.whiteLabel.favicon)) {
      rs.favicon = rs.customer.whiteLabel.favicon;
    } else {
      rs.favicon = "../res/cc_favicon.png";
    }

    rs.whiteLabel = rs.customer.whiteLabel;

    // initialize the client's white-label chat provider, if relevant
    rs.whiteLabel.chatProvider = scp.getChatProvider(
      rs.whiteLabel.chatProviderType
    );
    var initializedChat = rs.initializeWhiteLabelChat(rs.whiteLabel);
    rs.whiteLabel.initializedChatProvider = initializedChat;

    if (
      !initializedChat &&
      rs.user.internal &&
      !rs.embeddedView.active &&
      (!rs.user.partner || rs.user.partner !== "VENDASTA")
    ) {
      loadZendeskChat();
    }

    if (
      scp.isNotEmpty(rs.whiteLabel.sidebarStyle) &&
      scp.isEmpty(rs.whiteLabel.sidebarStyle.backgroundColor)
    ) {
      rs.whiteLabel.sidebarStyle.backgroundColor = "#353851";
      rs.whiteLabel.sidebarStyle.color = "#ccd8d8";
    }

    if (
      scp.isNotEmpty(rs.whiteLabel.headerStyle) &&
      scp.isEmpty(rs.whiteLabel.headerStyle.backgroundColor)
    ) {
      rs.whiteLabel.headerStyle.backgroundColor = "#7787f7";
      rs.whiteLabel.headerStyle.color = "#ffffff";
    }
  } else {
    rs.companyName = "Cloud Campaign";
    rs.favicon = "../res/cc_favicon.png";

    // load chat helper and initialize Zendesk chat
    if (
      (!rs.user.partner || rs.user.partner !== "VENDASTA") &&
      !rs.embeddedView.active
    ) {
      loadZendeskChat();
    }
  }
}

function instantiateBrands(brandList, newBrands, selectedBrand) {
  let newBrandList = brandList;

  for (var i = 0; i < newBrands?.length; i++) {
    const brand = newBrands[i];
    const selectedBrandCheck = selectedBrand ? brand.id !== selectedBrand?.id : true;

    if (isNotEmpty(brand) && selectedBrandCheck) {
      newBrandList.push(new Brand(brand));
    }
  }

  return newBrandList;
}

function dedupeWorkspaceIds (list) {
  let uniqueList = [...new Set(list)];

  return uniqueList || [];
}

function ingestBrands(brands, brandList, brandMap) {
  for (var i = 0; i < brands?.length; i++) {
    const brand = brands[i];
    if (isNotEmpty(brand) && brandMap[brand.id] === undefined) {
      const instantiatedBrand = new Brand(brand);
      brandMap[brand.id] = instantiatedBrand;
      brandList.push(instantiatedBrand);
    }
  }
}

function ingestUsers(users, userList) { // All this does now is do some picture logic. I don't really get why.
  for (var i = 0; i < users.length; i++) {
    if (isNotEmpty(users[i])) {
      users[i].pictureUrl = users[i].pictureUrl || "../res/user-no-picture.png";
      // using non-cc branded s3 bucket if default image is stored there
      users[i].pictureUrl =
        users[i].pictureUrl === "https://cloudcampaign.io/res/ninja_avatar.png"
          ? "https://pcore-customer-media.s3.amazonaws.com/app/static/ninja_avatar.png"
          : users[i].pictureUrl;
      userList.push(users[i]);
    }
  }
}

function countSocialAccounts(accountList) {
  let count=0;

  accountList?.forEach((account) => {
    if (doesPlatformSupportDirectPublishing(account.platformType)) {
      count++;
    } 
  });
  return count;
}

function doesPlatformSupportDirectPublishing(platformType) {
  let platformsSupportDirectPublishing = [
    {
      "type": "TWITTER",
      "supportsDirectPublishing": false
    },
    {
      "type": "FACEBOOK",
      "supportsDirectPublishing": true
    },
    {
      "type": "LINKEDIN",
      "supportsDirectPublishing": true
    },
    {
      "type": "GMB",
      "supportsDirectPublishing": true
    },
    {
      "type": "INSTAGRAM",
      "supportsDirectPublishing": true
    },
    {
      "type": "YOUTUBE",
      "supportsDirectPublishing": true
    },
    {
      "type": "PINTEREST",
      "supportsDirectPublishing": true
    },
    {
      "type": "TIKTOK",
      "supportsDirectPublishing": true
    },
    {
      "type": "THREADS",
      "supportsDirectPublishing": true
    },
    {
      "type": "OTHER",
      "supportsDirectPublishing": true
    },
    {
      "type": "STORIES",
      "supportsDirectPublishing": false
    },
    {
      "type": "SNAPCHAT",
      "supportsDirectPublishing": false
    },
    {
      "type": "CLUBHOUSE",
      "supportsDirectPublishing": false
    },
    {
      "type": "TUMBLR",
      "supportsDirectPublishing": false
    },
    {
      "type": "REDDIT",
      "supportsDirectPublishing": false
    },
    {
      "type": "EMAIL",
      "supportsDirectPublishing": false
    },
    {
      "type": "GOOGLE_PLUS",
      "supportsDirectPublishing": false
    },
  ];

  let platform = platformsSupportDirectPublishing.find(({type}) => type === platformType)
    if (platformType === platform.type) {
      return platform.supportsDirectPublishing;
    } 
  
  return false;
}

const monthNames = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sept",
	"Oct",
	"Nov",
	"Dec",
];

function prettyDate(date) {
	return (
		monthNames[date.getUTCMonth()] +
		" " +
		date.getUTCDate() +
		", " +
		date.getUTCFullYear()
	);
};

export {
  isUndefined,
  isEmpty,
  isNotEmpty,
  brandSearchFilter,
  userSearchFilter,
  isVendastaPartner,
  displayVendastaBanner,
  determineAndSetIfUserIsInternal,
  setAdminBannerVisibility,
  setWhiteLabelAndChat,
  ingestBrands,
  ingestUsers,
  countSocialAccounts,
  instantiateBrands,
  dedupeWorkspaceIds,
  Brand,
  User,
  prettyDate,
  monthNames
};
